@if (router.url !== '/') {
<div class="search-bar-container">
    <div class="container">
        @if (offerLinesActive() && offerLines().length > 0) {
        <div class="offer-lines-mobile">
            @for (line of offerLines(); track line) {
                <h3>{{ line }}</h3>
            }
        </div>
        }
        <div class="search-bar">
            <mat-icon aria-hidden="false" aria-label="keyboard_arrow_right icon" fontIcon="search" />
            <input type="search" [placeholder]="'category.searchPlaceHolder' | translate" [(ngModel)]="listFilter" />
        </div>
        @if (offerLinesActive() && offerLines().length > 0) {
        <div class="offer-lines">
            @for (line of offerLines(); track line) {
                <h3>{{ line }}</h3>
            }
        </div>
        }
    </div>
    <div class="mat-select">
        <mat-form-field>
            <mat-label>{{ 'category.sorting' | translate }}</mat-label>
            <mat-select id="statuses">
                <mat-option [value]="'materials.newestFirst' | translate" (click)="orderByNewest()">
                    {{ 'materials.newestFirst' | translate }}
                </mat-option>

                <mat-option [value]="'materials.ascendingPrice' | translate" (click)="orderbyAscPrice()">
                    {{ 'materials.ascendingPrice' | translate }}
                </mat-option>

                <mat-option [value]="'materials.descendingPrice' | translate" (click)="orderbyDescPrice()">
                    {{ 'materials.descendingPrice' | translate }}
                </mat-option>

                <mat-option [value]="'materials.titleA_Z' | translate" (click)="orderbyTitleAbc()">
                    {{ 'materials.titleA_Z' | translate }}
                </mat-option>
            </mat-select>
        </mat-form-field>
    </div>
</div>
}
@if (router.url !== '/') {
<div class="materials-container">
    @if (orderableProducts.length > 0) {
    <div class="soon-published">
        <div class="soon-pub">
            <h3>{{ category?.name! | uppercase }}</h3>
        </div>
    </div>
    }
    @if (orderableProducts.length > 0) {
    <div class="soon-container-home">
        <div class="main">
            @for (publication of filteredPublication; track publication; let i = $index) {
            <div class="material-container-soon">
                <div class="books">
                    <a routerLink="/book/{{ publication.routerLink }}"><img [src]="publication.url" /></a>
                </div>
                <div class="book-infos">
                    <span>{{ publication.author }}</span><br />
                    <span>{{ publication.title }}</span><br />
                    <span class="available">
                        @if (publication.isAvailable) {
                        <span>{{ 'materials.publishedBook' | translate }} </span>
                        }
                        @if (!publication.isAvailable) {
                        <span> {{ 'materials.expectedPublicationDate' | translate }}</span>
                        }
                        {{ publication.available | dateUtil }} </span><br />
                    @if (publication.webshopPriceActive || publication.discountPriceActive || publication.hasPreorder) {
                    <span> Ár a könyvön: {{ publication.oldPrice | currency: 'Ft' : 'symbol' : '1.0-0' }} </span>
                    }
                    <br />
                    <span [ngStyle]="{ color: 'red', 'font-weight': 'bold' }">
                        {{ publication.typeOfPrice }}
                        {{ publication.originalPrice | currency: 'Ft' : 'symbol' : '1.0-0' }} </span><br />
                </div>
                @if (!publication.hasPreorder) {
                <div class="shopping-cart">
                    @if (publication.quantityOfSupply !== 0) {
                    <button (click)="addToCart(publication)">
                        {{ 'shoppingCart.putIntoCart' | translate }}
                    </button>
                    }
                    @if (publication.quantityOfSupply === 0) {
                    <button class="inactive-button"
                        [ngStyle]="{ opacity: '0.5', cursor: 'auto', background:'lightgray',color:'black','font-weight':'bold' }">
                        {{ 'shoppingCart.outOfStock' | translate }}
                    </button>
                    }
                </div>
                }
                @if (publication.hasPreorder) {
                <div class="shopping-cart">
                    @if (publication.quantityOfSupply !== 0) {
                    <button class="preorder" (click)="addToCart(publication)">{{'category.preorderButtonTitle' |
                        translate}}</button>
                    }
                    @if (publication.quantityOfSupply === 0) {
                    <button class="inactive-button"
                        [ngStyle]="{ opacity: '0.5', cursor: 'auto', background:'lightgray',color:'black','font-weight':'bold'  }">
                        {{ 'shoppingCart.outOfStock' | translate }}
                    </button>
                    }
                </div>
                }
                <div class="book-border-container"></div>
            </div>
            }
            <div class="placeholder"></div>
            <div class="placeholder"></div>
            <div class="placeholder"></div>
            <div class="placeholder"></div>
            <div class="placeholder"></div>
        </div>
    </div>
    }
</div>
}
